import { AudiencesInsightsDemographicsEmptyState } from 'modules/audiences/components/AudiencesInsightsDemographics/AudiencesInsightsDemographicsEmptyState';
import { GRAPHS } from 'modules/campaigns/constants/graphTypes';
import * as FIELDS from '../../fields';
import metrics from '../../metrics';

const graph = {
    type: GRAPHS.BAR,
    endpoint: 'campaign-report-by-audience-insights-demographics',
    metrics: [
        metrics.SPENT,
        metrics.IMPRESSIONS_PCT,
        metrics.CLICKS_PCT,
        metrics.AVERAGE_CPC,
        metrics.VCTR,
        metrics.CVR,
        metrics.CONVERSIONS_PCT,
        metrics.CPA,
        metrics.VCPM,
        metrics.ROAS,
    ],
    maxAllowedSelectedMetrics: 4,
    maxXAxisValues: 8,
    shouldUseGridDataSrc: true,
    displayTotalsInLegendRow: false,
    enableLongTextTickFormatting: true,
    graphProps: {
        xAxisDataKey: FIELDS.AUDIENCE_NAME.field,
    },
    customOverlayComponent: AudiencesInsightsDemographicsEmptyState,
    shouldUseCustomOverlayComponent: true,
};

export default graph;
